import { createSlice } from "@reduxjs/toolkit";
import { addDocumentToKnowledge, addSegmentToDocument, createKnowledge, deleteBulkDocument, deleteBulkSegments, deleteKnowledge, getDocumentDetail, getKnowledge, getKnowledgeDetail, initKnowledge, updateKnowledge, updateSegment } from "./thunk";


export const initialState = {
  dataset: [],
  knowledgeDetail: {},
  documents: [],
  documentDetail: {},
  Segments: [],
  QuestionAnswers: [],
  KnowledgeBaseVectors: [],
  loading: false,
  error: null,
};

const knowledgeSlice = createSlice({
  name: "knowledge",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    // Get list of knowledge bases
    builder.addCase(getKnowledge.fulfilled, (state: any, action: any) => {
      state.dataset = action.payload;
      state.loading = false;
    });
    builder.addCase(getKnowledge.rejected, (state: any, action: any) => {
      state.error = (action.payload as { error?: any })?.error || null;
      state.loading = false;
    });
    builder.addCase(getKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Get knowledge base detail
    builder.addCase(getKnowledgeDetail.fulfilled, (state: any, action: any) => {
      state.knowledgeDetail = action.payload;
      state.documents = action.payload.documents || [];
      state.loading = false;
    });
    builder.addCase(getKnowledgeDetail.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(getKnowledgeDetail.pending, (state) => {
      state.loading = true;
    });

    // Create new knowledge base
    builder.addCase(createKnowledge.fulfilled, (state: any, action: any) => {
      state.dataset.push(action.payload);
      state.loading = false;
    });
    builder.addCase(createKnowledge.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(createKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Delete knowledge base
    builder.addCase(deleteKnowledge.fulfilled, (state: any, action: any) => {
      state.dataset = state.dataset.filter((item: any) => item.id !== action.payload);
      state.loading = false;
    });
    builder.addCase(deleteKnowledge.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(deleteKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Update knowledge base
    builder.addCase(updateKnowledge.fulfilled, (state: any, action: any) => {
      state.dataset = state.dataset.map((item: any) =>
        item.id === action.payload.id ? { ...item, ...action.payload } : item
      );
      state.loading = false;
    });
    builder.addCase(updateKnowledge.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(updateKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Initialize knowledge base
    builder.addCase(initKnowledge.fulfilled, (state: any, action: any) => {
      state.knowledgeDetail = action.payload;
      state.loading = false;
    });
    builder.addCase(initKnowledge.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(initKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Get document detail
    builder.addCase(getDocumentDetail.fulfilled, (state: any, action: any) => {
      state.documentDetail = action.payload;
      state.segments = action.payload.segments || [];
      state.KnowledgeBaseVectors = action.payload.KnowledgeBaseVectors || [];
      state.loading = false;
    });
    builder.addCase(getDocumentDetail.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(getDocumentDetail.pending, (state) => {
      state.loading = true;
    });

    // Delete many Documents
    builder.addCase(deleteBulkDocument.fulfilled, (state: any, action: any) => {
      state.knowledgeDetail.documents = state.knowledgeDetail.documents.filter((doc: any) => !action.payload.includes(doc.id));
      state.documents = state.documents.filter((doc: any) => !action.payload.includes(doc.id));
      state.loading = false;
    });
    builder.addCase(deleteBulkDocument.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(deleteBulkDocument.pending, (state) => {
      state.loading = true;
    });


    // Delete many Segments
    builder.addCase(deleteBulkSegments.fulfilled, (state: any, action: any) => {
      state.documentDetail.knowledgeBaseVectors = state.documentDetail.knowledgeBaseVectors.filter((seg: any) => !action.payload.includes(seg.id));
      state.loading = false;
    });
    builder.addCase(deleteBulkSegments.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(deleteBulkSegments.pending, (state) => {
      state.loading = true;
    });

    // Update Segment
    builder.addCase(updateSegment.fulfilled, (state: any, action: any) => {
      const { segmentId, payload } = action.meta.arg;
      state.documentDetail.knowledgeBaseVectors = state.documentDetail.knowledgeBaseVectors.map((seg: any) =>
        seg.id === segmentId ? { ...seg, ...payload } : seg
      );
      state.loading = false;
    });
    builder.addCase(updateSegment.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(updateSegment.pending, (state) => {
      state.loading = true;
    });

    // Add Document
    builder.addCase(addDocumentToKnowledge.fulfilled, (state: any, action: any) => {
      state.knowledgeDetail.documents.push(action.payload);
      state.loading = false;
    });
    builder.addCase(addDocumentToKnowledge.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(addDocumentToKnowledge.pending, (state) => {
      state.loading = true;
    });

    // Add Segment
    builder.addCase(addSegmentToDocument.fulfilled, (state: any, action: any) => {
      state.documentDetail.knowledgeBaseVectors.push(action.payload);
      state.loading = false;
    });
    builder.addCase(addSegmentToDocument.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
      state.loading = false;
    });
    builder.addCase(addSegmentToDocument.pending, (state) => {
      state.loading = true;
    });

  }
});

export default knowledgeSlice.reducer;
